import { Component, OnInit } from '@angular/core';
import { ComponentInterface } from '../../models/component.interface';
import { ComponentConfig } from '../../models/component-config.interface';

@Component({
  selector: 'app-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.css']
})
export class EmptyComponent implements ComponentInterface, OnInit {
  config: ComponentConfig;
  constructor() {

  }

  isLoading: boolean;

  ngOnInit() {
    this.isLoading = true;
  }


}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/empty/empty.component.ts